import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class BigWinComponent extends Game.src.component.BaseComponent {
    protected isWinAllLabel: boolean = false;
    protected waitClick: () => Promise<void>;

    static events = {
        START: "BigWinComponent.START",
        END: "BigWinComponent.END",
        START_COUNT: "BigWinComponent.START_COUNT",
        END_COUNT: "BigWinComponent.END_COUNT",
    }

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isWinAllLabel: () => this.isWinAllLabel
        };
    }

    onGameReady() {
        game.once('SET_WAIT_CLICK', ({waitClick}) => this.waitClick = waitClick);

        super.onGameReady();
    }

    checkBigWin(){
        if ((<SlotGameStore>game.store).gameData.winAmount >= (<SlotGameStore>game.store).gameData.bet * 45){
            return true;
        }
    }

    async showStartBigwinPopup() {
        const timeWaitPlayCounterAnimation = 2000;
        const container = game.tree.findByName("bigwin.bigwin_container");
        const text = game.tree.findByName("bigwin.bigwin_label");

        game.emit(BigWinComponent.events.START);

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 300, timeWait: 0});
        game.emit(BigWinComponent.events.START_COUNT);

        await Promise.race([
            this.waitClick(),
            game.onceDataPromise('Button.clicked', { component: 'bigWin', name: 'bigWin.click_button'}),
            game.utils.GameUtils.playCounterAnimation(text, { from: 0, to: (<SlotGameStore>game.store).gameData.winAmount, time: 3000, timeWait: 0 })
        ]);

        game.utils.removeCall(text._tween);
        text.options.text = (<SlotGameStore>game.store).toFormatMoney((<SlotGameStore>game.store).gameData.spinWinAmount);
        text.updateViewOptions();

        game.emit(BigWinComponent.events.END_COUNT);

        await game.utils.delay(timeWaitPlayCounterAnimation);

        game.emit(BigWinComponent.events.END);
    }

    async hideBigwinPopup() {
        const container = game.tree.findByName("bigwin.bigwin_container");

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 300, timeWait: 0});

        game.tree.findByName("bigwin.bigwin_label").options.text = "";
    }

    getFSMHandlers() {
        return {
            SHOW_WIN: {
                showBigWin: {
                    on: async () => {
                        this.isWinAllLabel = true;
                        await this.showStartBigwinPopup();
                        return this.hideBigwinPopup();
                    },
                    check: () => this.checkBigWin()
                }
            }
        }
    }

}

//@ts-ignore
Game.src.component.BigWinComponent = BigWinComponent;
